import { Component, input, model, output } from "@angular/core";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzButtonModule } from "ng-zorro-antd/button";

/**
 * General-purpose modal shell used across xwai-v2. Wraps nz-modal so callers
 * just project body content instead of repeating nz-modal's plumbing at
 * every call site.
 *
 * Default footer is Cancel/OK. Set `showDefaultFooter` to false when the
 * projected content supplies its own action buttons (e.g. a form's submit
 * row) instead.
 */
@Component({
  selector: "app-xwai-modal",
  standalone: true,
  imports: [NzModalModule, NzButtonModule],
  templateUrl: "./xwai-modal.component.html",
  styleUrl: "./xwai-modal.component.less",
})
export class XwaiModalComponent {
  readonly visible = model(false);

  readonly title = input<string>("");
  readonly width = input<number | string>(480);
  readonly closable = input(true);
  readonly maskClosable = input(true);

  /** Hide the built-in Cancel/OK row entirely — use when the projected
   * content (e.g. a form) supplies its own action buttons. */
  readonly showDefaultFooter = input(true);
  readonly okText = input("OK");
  readonly cancelText = input("Cancel");
  readonly okDisabled = input(false);
  readonly confirmLoading = input(false);

  /** Emitted on OK; caller decides whether/when to close `visible`. */
  readonly confirm = output<void>();
  /** Emitted on Cancel or mask/close click; visible is already closed. */
  readonly cancel = output<void>();

  protected handleOk(): void {
    this.confirm.emit();
  }

  protected handleCancel(): void {
    this.visible.set(false);
    this.cancel.emit();
  }
}
